"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePaymentChoiceWordingWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
require("react-datepicker/src/stylesheets/datepicker.scss");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var moment = require("moment/moment");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../../commonFunctions");
var AnnualHomePaymentChoiceWordingWidget = /** @class */ (function (_super) {
    __extends(AnnualHomePaymentChoiceWordingWidget, _super);
    function AnnualHomePaymentChoiceWordingWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            installmentsHasAmountRemaining: true,
            dataLoaded: false,
            policies: [],
        };
        return _this;
    }
    AnnualHomePaymentChoiceWordingWidget.prototype.componentDidMount = function () {
        var _this = this;
        var interaction = this.props.engine.getInteraction();
        var product = services_1.productHelper.isHome(interaction) ? services_1.ProductsEnum.HOME : services_1.ProductsEnum.WOLF_MOTOR;
        this.customerPortalService.getPolicies(product).subscribe(function (policies) {
            _this.setState({
                policies: policies
            });
            var policiesByProduct = policies.filter(function (policy) { return policy.products.includes(product); })
                .sort(function (a, b) { return moment(b.endDate).diff(a.endDate); });
            if (policiesByProduct && policiesByProduct.length > 0) {
                var policy = policiesByProduct[0];
                var agreementVersionIds = policy.policyHistoryList.map(function (ph) { return ph.id; });
                _this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds)
                    .subscribe(function (instalmentsInfo) {
                    var installmentsHasAmountRemaining = Math.abs(instalmentsInfo === null || instalmentsInfo === void 0 ? void 0 : instalmentsInfo.remainingAmount) !== 0;
                    _this.setState({
                        installmentsHasAmountRemaining: installmentsHasAmountRemaining,
                        dataLoaded: true
                    });
                });
            }
        });
    };
    AnnualHomePaymentChoiceWordingWidget.prototype.render = function () {
        if (this.state.dataLoaded) {
            var isRenewalWindow = this.props.interaction.uistate.renewalWindow;
            var installmentsHasAmountRemaining = this.state.installmentsHasAmountRemaining;
            var upfrontPaymentAmount = (0, commonFunctions_1.getUpfrontPaymentAmount)(this.props.interaction.factors);
            var remainingPaymentAmount = (0, commonFunctions_1.getRemainingSpreadAmount)(this.props.interaction.factors);
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { children: "All figures include Insurance Premium Tax" }), isRenewalWindow &&
                        (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-bold mb-0", children: ["This means your next year's renewal price will be ", (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.uistate.totalRenewalAmount)] }), (upfrontPaymentAmount && installmentsHasAmountRemaining) &&
                        (0, jsx_runtime_1.jsxs)("p", { className: "mb-0", children: ["You\u2019ll need to pay ", (0, jsx_runtime_1.jsx)("strong", { children: upfrontPaymentAmount }), " upfront now. The remaining balance of ", (0, jsx_runtime_1.jsx)("strong", { children: remainingPaymentAmount }), " can also be paid now, or you can add it to your monthly payments."] }), (!installmentsHasAmountRemaining && isRenewalWindow) &&
                        (0, jsx_runtime_1.jsx)("p", { children: "As you have no outstanding monthly payments left, this amount will need to be paid on a card now." })] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualHomePaymentChoiceWordingWidget.prototype, "customerPortalService", void 0);
    return AnnualHomePaymentChoiceWordingWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomePaymentChoiceWordingWidget = AnnualHomePaymentChoiceWordingWidget;
//# sourceMappingURL=AnnualHomePaymentChoiceWordingWidget.js.map